module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-report-box-button-2-icon-62d88ffbe5c57396f1888110da8d8085.svg";